import React, { useEffect } from "react";
import '../calendar.css';
import { useTranslation } from "react-i18next";


interface AYSProps {
    title: string
    message: string
    callback: (a: boolean) => any
    buttons?: React.JSX.Element[]
}

interface AYSButtonProps {
    text: string;
    callback?: (event: any) => any;
    type?: 'delete' | 'validate' | 'cancel';
}

export const AYSButton = ({
    text,
    callback = () => undefined,
    type = 'cancel'
}: AYSButtonProps) => {

    return (
        <button type="button" className={"form-button-" + type}
            onClick={callback}>
            {text}
        </button>
    );
}

const AreYouSure = ({ title, message, callback, buttons }: AYSProps) => {
    const { t } = useTranslation();
    if (buttons == null) {
        buttons = [
            <AYSButton
                text={t('yes')}
                callback={e => callback(true)}
                type="delete"
            />,
            <AYSButton
                text={t('cancel')}
                callback={e => callback(false)}
                type="cancel"
            />
        ]
    }

    return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 flex items-center justify-center animate-fadeIn "
        onMouseDown={event => { if (event.target.id === 'modal-confirm') { callback(false) } }}
        id="modal-confirm"
    >
        <div className="bg-white p-5 rounded shadow-lg w-1/3 animate-shake">
            <h2 className="text-lg font-semibold">{t(title)}</h2>
            <h2 className="text-md font-semibold">{t(message)}</h2>
            <div className="flex flex-row justify-between mt-4 mx-2">
                {buttons}
            </div>
        </div>
    </div>;
}
export default AreYouSure;